// The blue pill behind the current tab, sliding from one tab to the next
// (4 Nov 2026: the move between pages should be felt, not jump). It sits in
// the tabs bar as its first child and follows the button marked aria-current,
// through resizes and the phone's scrolling tab row. The first placement does
// not slide. It finds the bar through its own element, whose ref is set
// before this effect runs (a ref on the bar itself is not, on first mount).
import { useLayoutEffect, useRef, useState } from 'react';

type Box = { x: number; y: number; w: number; h: number };

export function TabInk({ active }: { active: string }) {
  const ink = useRef<HTMLSpanElement>(null);
  const [box, setBox] = useState<Box | null>(null);
  const [ready, setReady] = useState(false);
  useLayoutEffect(() => {
    const el = ink.current?.parentElement;
    if (!el) return;
    const place = () => {
      const a = el.querySelector<HTMLElement>('[aria-current="page"]');
      const b = a ? { x: a.offsetLeft, y: a.offsetTop, w: a.offsetWidth, h: a.offsetHeight } : null;
      setBox((o) => (o && b && o.x === b.x && o.y === b.y && o.w === b.w && o.h === b.h ? o : b));
    };
    place();
    // On a phone the tab row scrolls: bring the new tab into view.
    el.querySelector<HTMLElement>('[aria-current="page"]')?.scrollIntoView?.({ block: 'nearest', inline: 'nearest' });
    const ro = new ResizeObserver(place);
    ro.observe(el);
    el.querySelectorAll('.tab').forEach((c) => ro.observe(c));
    return () => ro.disconnect();
  }, [active]);
  // Slide only from the second placement on.
  useLayoutEffect(() => { if (box && !ready) requestAnimationFrame(() => setReady(true)); }, [box, ready]);
  return (
    <span ref={ink} className={'tab-ink' + (ready ? ' on' : '')} aria-hidden="true"
      style={box ? { width: box.w, height: box.h, transform: `translate(${box.x}px, ${box.y}px)` } : { display: 'none' }} />
  );
}
